/* eslint-disable no-nested-ternary */
import { theme } from '@styles';

export const colors = {
  notPassed: theme.colors.alto[30],
  passed: theme.colors.schoolBusYellow[100],
  passedCorrect: theme.colors.brightGreen,
  passedWrong: theme.colors.red[100],
};

export const barLayoutByProps = ({ isCorrect, isPassed, withCorrection }) => ({
  backgroundColor: isPassed
    ? withCorrection
      ? isCorrect
        ? colors.passedCorrect
        : colors.passedWrong
      : colors.passed
    : colors.notPassed,
});
